import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { forwardRef, useContext } from 'react';
import { prefix } from '../../../tools/settings';
import cx from 'classnames';
import { Styled } from './Step.styles';
import { WizardContext } from '../Wizard';
import { jsx as _jsx } from "react/jsx-runtime";

var useWizardContext = function useWizardContext() {
  return useContext(WizardContext);
};

var Step = forwardRef(function (_ref, ref) {
  var id = _ref.id,
      isFullWidth = _ref.isFullWidth,
      children = _ref.children,
      stepIndex = _ref.stepIndex;

  var _useWizardContext = useWizardContext(),
      activeStepIndex = _useWizardContext.activeStepIndex;

  var className = cx(_defineProperty({}, "".concat(prefix, "-wizard__step--isActive"), activeStepIndex === stepIndex));
  return _jsx(Styled.Step, {
    ref: ref,
    id: id,
    className: className,
    children: _jsx(Styled.StepInner, {
      isFullWidth: isFullWidth,
      children: children
    })
  });
});
export default Step;